import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ImageFilter from '../components/filters/image-filter';
import ImagesTable from '../components/tables/images-table';

const ImagesListRoute: FC = () => {
  const [filters, setFitlers] = useState()
  const navigate = useNavigate()


  return (<>
    <PageHeader
      title="تصاویر"
      style={{ padding: " 16px 0" }}
      extra={[
        <Button key="add"><Link to="/images-form">افزودن</Link></Button>,
      ]}
      onBack={() => navigate(-1)}
    />
    <ImageFilter onFinish={setFitlers} />
    <ImagesTable  filters={filters}/>
  </>);
}

export default ImagesListRoute;
